import { Tabs, TabsProps } from 'antd';
import { useHistoryState } from 'hook/useStateHistory';
import { AppProps } from 'presentation/App';
import { BUYER_CLASSIFICATION, SELLER_CLASSIFICATION } from 'presentation/components/HeaderRightComponent';
import { PageTitle } from 'presentation/components/PageTitle';
import {
    changeImplementerClassification,
    setGrantPoint,
} from 'presentation/redux/features/authen/authenSlice';
import { useAppSelector } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { useSearchParams, useParams } from 'react-router-dom';
import { commonHelpers } from 'utilities/helpers';
import { MemberEntity } from './models/CardModel';
import TAB1Children from './tab1';
import TAB2Children from './tab2';
import TAB3Children from './tab3';
import TAB4Children from './tab4';
import TAB5Children from './tab5';
import TAB6Children from './tab6';

export const WF_PROCESS_TODO = [
    {
        wfProcessCurrentId: '10-0010-0030-0000',
        wfProcessCurrentName: '部屋情報入力',
    },
    {
        wfProcessCurrentId: '10-0040-0000-0000',
        wfProcessCurrentName: '査定依頼',
    },
    {
        wfProcessCurrentId: '10-0080-0000-0000',
        wfProcessCurrentName: '本人確認の実施',
    },
    {
        wfProcessCurrentId: '10-1020-0000-0000',
        wfProcessCurrentName: '媒介契約締結',
    },
];

const CU00202Page = (prop: AppProps) => {
    const [searchParams] = useSearchParams();
    
    // Cookieから初期値を取得（新しいタブでも正しい値を設定するため）
    const getInitialType = () => {
        const sellingCookie = commonHelpers.getCookie('selling');
        if (sellingCookie === 'true') {
            return SELLER_CLASSIFICATION;
        }
        return 0; // デフォルト値（後で初期化ロジックで設定される）
    };
    
    const [type, setType] = useHistoryState('type', getInitialType());
    const [tabIndex, setTabIndex] = useHistoryState('tabIndex', '1');
    const [activeKey, setActiveKey] = useState<string>(searchParams.get('tab') || tabIndex);
    const dispatch = useDispatch();
    const userSlice = useAppSelector((state) => state.user);
    const [isNotice, setNotice] = useState<boolean>(false);
    const { defaultValue } = useParams<string>();
    const [initialValue, setInitialValue] = useState<number | null>(null);

    React.useEffect(() => {
        setInitialValue(Number(defaultValue));
      }, [defaultValue]);
    
      React.useEffect(() => {
        if (initialValue !== null) {
          setInitialValue(null);
        }
      }, [initialValue]);
      
    const setMember = (member?: MemberEntity) => {
        dispatch(setGrantPoint(member?.grantPoint));
    };

    // 初期化: CookieとReduxの状態を同期
    const [isInitialized, setIsInitialized] = React.useState(false);
    
    React.useEffect(() => {
        if (isInitialized) return;
        
        // Cookieの値を最優先にする（ログイン後もCookieの値を保持）
        const sellingCookie = commonHelpers.getCookie('selling');
        let initialClassification: number;
        
        if (sellingCookie === 'true') {
            // Cookieに「selling=true」がある場合は、売りたいを設定
            initialClassification = SELLER_CLASSIFICATION;
        } else if (userSlice?.implementerClassification) {
            // Cookieがない場合は、Reduxの状態を使用
            initialClassification = userSlice.implementerClassification;
        } else if (type && type !== 0) {
            // typeが既に設定されている場合はそれを使用
            initialClassification = type;
        } else {
            // どれもない場合はデフォルト値（買いたい）
            initialClassification = BUYER_CLASSIFICATION;
        }
        
        setType(initialClassification);
        dispatch(changeImplementerClassification(initialClassification));
        
        // Cookieと同期
        if (initialClassification === SELLER_CLASSIFICATION) {
            commonHelpers.setCookie('selling', 'true');
        } else {
            commonHelpers.deleteCookie('selling');
        }
        
        setIsInitialized(true);
    }, [userSlice?.implementerClassification, type, isInitialized]);

    // Reduxの状態が変更されたときにtypeを同期（初期化後）
    React.useEffect(() => {
        if (isInitialized && userSlice?.implementerClassification && type !== userSlice.implementerClassification) {
            setType(userSlice.implementerClassification);
        }
    }, [userSlice?.implementerClassification, isInitialized]);

    window.onpopstate = (data) => {
        setActiveKey(data.state.tabIndex || '1');
    };
    const alert = (
        <div
            style={{
                position: 'absolute',
                background: 'red',
                width: 10,
                height: 10,
                borderRadius: '50%',
                right: -10,
                top: -5,
            }}
        >
            &nbsp;
        </div>
    );
    const TabInfomation: TabsProps['items'] = [
        {
            label:
                type == BUYER_CLASSIFICATION ? (
                    <div style={{ position: 'relative' }}>
                        {isNotice && activeKey == '1' && alert}選定
                    </div>
                ) : (
                    <div style={{ position: 'relative' }}>
                        {isNotice && activeKey == '1' && alert}査定
                    </div>
                ),
            key: '1',
            children: (
                <TAB1Children
                    propertyUseCase={prop.propertyUseCase}
                    type={type}
                    tabId={1}
                    setMember={setMember}
                    isLoading={activeKey == '1'}
                    setNotice={setNotice}
                />
            ),
        },
        {
            label:
                type == BUYER_CLASSIFICATION ? (
                    <div style={{ position: 'relative' }}>
                        {isNotice && activeKey == '2' && alert}入札
                    </div>
                ) : (
                    <div style={{ position: 'relative' }}>
                        {isNotice && activeKey == '2' && alert}出品
                    </div>
                ),
            key: '2',
            children: (
                <TAB2Children
                    propertyUseCase={prop.propertyUseCase}
                    type={type}
                    tabId={2}
                    setMember={setMember}
                    isLoading={activeKey == '2'}
                    setNotice={setNotice}
                />
            ),
        },
        {
            label: (
                <div style={{ position: 'relative' }}>
                    {isNotice && activeKey == '3' && alert}契約
                </div>
            ),
            key: '3',
            children: (
                <TAB3Children
                    propertyUseCase={prop.propertyUseCase}
                    type={type}
                    tabId={3}
                    setMember={setMember}
                    isLoading={activeKey == '3'}
                    setNotice={setNotice}
                />
            ),
        },
        {
            label: (
                <div style={{ position: 'relative' }}>
                    {isNotice && activeKey == '4' && alert}決済
                </div>
            ),
            key: '4',
            children: (
                <TAB4Children
                    propertyUseCase={prop.propertyUseCase}
                    type={type}
                    tabId={4}
                    setMember={setMember}
                    isLoading={activeKey == '4'}
                    setNotice={setNotice}
                />
            ),
        },
        {
            label: (
                <div style={{ position: 'relative' }}>
                    {isNotice && activeKey == '5' && alert}引き継ぎ
                </div>
            ),
            key: '5',
            children: (
                <TAB5Children
                    propertyUseCase={prop.propertyUseCase}
                    type={type}
                    tabId={5}
                    setMember={setMember}
                    isLoading={activeKey == '5'}
                    setNotice={setNotice}
                />
            ),
        },
        {
            label: (
                <div style={{ position: 'relative' }}>
                    {isNotice && activeKey == '6' && alert}終了
                </div>
            ),
            key: '6',
            children: (
                <TAB6Children
                    propertyUseCase={prop.propertyUseCase}
                    type={type}
                    tabId={6}
                    setMember={setMember}
                    isLoading={activeKey == '6'}
                    setNotice={setNotice}
                />
            ),
        },
    ];
    const onChange = (key: string) => {
        window.history.pushState(
            {},
            '',
            `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_02}#${key}`,
        );
        setActiveKey(key);
        setTabIndex(key);
        setNotice(false);
    };
    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                textAlign: 'center',
            }}
            className="CU-002-02-container relative "
        >
            <Helmet>
                <title>ワンルームオークション</title>
                <meta
                    name="description"
                    content="Dashboard screen displays the status of a real estate. Each of a real estate has a buyer and a seller. Therefore, from the view of user, dashboard screen has 2 modes. The first mode is of the buyer and the other is of the seller."
                />
                <meta name="keywords" content="" />
                <link
                    rel="canonical"
                    href={`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_02}`}
                />
            </Helmet>
            <PageTitle title="ホーム" showTypeSelect defalultData={initialValue} />
            <Tabs
                defaultActiveKey={activeKey}
                className="tab-dashboard-title-container"
                items={TabInfomation}
                onChange={onChange}
                activeKey={activeKey}
            />
        </div>
    );
};

export default CU00202Page;
